import { Component, OnInit } from '@angular/core';
import { RegularComponent } from '../regular/regular.component';
import { SatisfactionComponent } from '../satisfaction/satisfaction.component';
import { SurveyComponent } from '../survey/survey.component';
import { Globals } from '../../globals';

@Component({
  selector: 'app-assessment-sections',
  templateUrl: './assessment-sections.component.html',
    styleUrls: ['./assessment-sections.component.scss'],
    providers: [RegularComponent, SatisfactionComponent, SurveyComponent]
})
export class AssessmentSectionsComponent implements OnInit {
    currentTab: number = 0;

    constructor(
        private _RegularComponent: RegularComponent,
        private _SatisfactionComponent: SatisfactionComponent,
        private _SurveyComponent: SurveyComponent,
        private _Globals: Globals ) { }

    ngOnInit() { }

    ngOnDestroy() {
        this._Globals.gridApis = [];
    }

    tabSelect(tabIndex: any) {
        tabIndex = parseInt(tabIndex);
        console.log(tabIndex);
        this.currentTab = tabIndex;

        switch (tabIndex) {
            case 1: {
                this.executeSizeToFit(this._SatisfactionComponent, 0);
                break;
            }
            case 2: {
                this.executeSizeToFit(this._SurveyComponent, 1); 
                break;
            }
        }
    }

    executeSizeToFit(gridApi: any, tabIndex) {
        gridApi.sizeToFit(this._Globals.gridApis[tabIndex]);
    }


}
